/**
 * ModeratorSlice — consensus snapshot, interrupt overlay state, pending flag.
 * Invariants: pushConsensus always clears consensusPending; interrupt flag is binary.
 */
import type { StateCreator } from "zustand";
import type { ConsensusSnapshot } from "../../domain/types";
import type { DebateStore } from "../debateStore";

export interface ModeratorSlice {
  consensus: ConsensusSnapshot | null;
  interruptActive: boolean;
  lastModeratorPivot: string | null;
  consensusPending: boolean;

  pushConsensus(snapshot: ConsensusSnapshot): void;
  triggerInterrupt(pivot: string): void;
  resolveInterrupt(): void;
  setConsensusPending(pending: boolean): void;
  resetModerator(): void;
}

export type ModeratorSliceCreator = StateCreator<
  DebateStore,
  [["zustand/immer", never]],
  [],
  ModeratorSlice
>;

export const createModeratorSlice: ModeratorSliceCreator = (set) => ({
  consensus: null,
  interruptActive: false,
  lastModeratorPivot: null,
  consensusPending: false,

  pushConsensus: (snapshot) => {
    set((state) => {
      state.consensus = snapshot;
      state.consensusPending = false;
    });
  },

  triggerInterrupt: (pivot) => {
    set((state) => {
      state.interruptActive = true;
      state.lastModeratorPivot = pivot;
    });
  },

  resolveInterrupt: () => {
    set((state) => {
      state.interruptActive = false;
    });
  },

  setConsensusPending: (pending) => {
    set((state) => {
      state.consensusPending = pending;
    });
  },

  resetModerator: () => {
    set((state) => {
      state.consensus = null;
      state.interruptActive = false;
      state.lastModeratorPivot = null;
      state.consensusPending = false;
    });
  },
});
